import styled from 'styled-components'

export const HorizontalBarChartWrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`
